// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3an0G","content":"GlobalSearch_content__32Oak"};